import { Route, Routes } from "react-router-dom"
import Registration from "../../pages/Payment/Registration"
import { SuccessIdentification } from "../../pages/Payment/sucess-identification"
import FailedIdentification from "../../pages/Payment/failed-identification"
import { ErrorIdentification } from "../../pages/Payment/error-identification"
import { Payments } from "../../pages/Payment/payments"
import { PaymentFinally } from "../../pages/Payment/payment-finally"
import AuthOtpConfirmation from "../../pages/AuthOtpConfirmation"

import { ROUTES_PATHS } from "../../utils/constants"
import Identification from "../../pages/Payment/Identification"
import IdentificationPreCheck from "../../pages/Payment/IdentificationPreCheck"
import { useAuthRedirect } from "../../hooks/useAuthRedirect"
import RegistrationOtpConfirmation from "../../pages/RegistrationOtpConfirmation"
import { Refill } from "../../pages/Payment/refill"
import { PaymentConfirmation } from "../../pages/Payment/confirmation"
import PassportPage from "../../pages/PassportPage"

const PaymentFlow = () => {
  useAuthRedirect(
    `/${ROUTES_PATHS.topUpMbankAccount}`,
    `/${ROUTES_PATHS.topUpMbankAccountPayments}`,
  )

  return (
    <Routes>
      <Route path="registration" element={<Registration />} />
      <Route path="registration/otp" element={<RegistrationOtpConfirmation flow="identification" />} />
      <Route
        path="auth"
        element={
          <AuthOtpConfirmation
            redirectUrlProp={`/${ROUTES_PATHS.topUpMbankAccountPayments}`}
          />
        }
      />
      <Route path="identification/success" element={<SuccessIdentification />} />
      <Route path="identification/failed" element={<FailedIdentification />} />
      <Route path="absent-data" element={<ErrorIdentification />} />
      <Route path="identification" element={<IdentificationPreCheck />} />
      <Route path="identification/:id" element={<Identification />} />
      <Route path="identification/uprid" element={<PassportPage />} />
      <Route path="payments" element={<Refill />} />
      <Route path="payments/bank" element={<Payments />} />
      <Route path="payments/confirmation" element={<PaymentConfirmation />} />
      <Route path="payments/success" element={<PaymentFinally />} />
      <Route path="payments/error" element={<PaymentFinally />} />
    </Routes>
  )
}

export default PaymentFlow
